import { connection, findRecord } from "./services";

type dataType = {
  id: number;
  cityid: number;
  main_tag_id: number;
  cover_pic: string;
  title: string;
  stm: number;
  ftm: number;
  hardshiplevel: number;
  tourleaderuid: number;
  mainprice: number;
  essentials_accessories: string;
  insurance: number;
  visa: number;
  isspecial: number;
  main_capacity: number;
  public_capacity: number;
  frozen_reserved: number;
  complate_reserved: number;
  mtm: number;
  uptm: number;
  muid: number;
  upuid: number;
  main_status: number;
  leader_user: [
    {
      fname: string;
      lname: string;
    }
  ];
  tour_main_tag_record: [];
  city: [
    {
      id: number;
      title: string;
      provinceid: number;
    }
  ];
  attraction: [
    {
      id: number;
      tour_attraction_id: number;
      tour_id: number;
      cityid: number;
      title: string;
      description: string;
      txtbody: string;
      mainpic: string;
    }
  ];
  tags: [
    {
      id: number;
      tour_tag_id: number;
      tour_id: number;
      ismain: number;
      title: string;
      description: string;
      icon: string;
    }
  ];
  tour_daily_schedule: [];
  weather: [
    {
      id: number;
      tour_id: number;
      code: number;
      val: string;
    }
  ];
};

type tagType = {
  id: number;
  title: string;
};

export const getInfo = async (): Promise<{
  data: dataType[];
  tags: tagType[];
}> => {
  let theTags: tagType[];
  let res: any;
  res = await findRecord("tour_tags", {
    conditions: "ismain/=/1",
    fields: "id, title",
    tbl_name: "",
  });
  theTags = res;
  res = await connection("fulltour");
  let temp = res.data.filter((value: dataType) => value.main_status == 4);
  return { data: temp, tags: theTags };
};
